var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { staticClass: "fixed-bar", attrs: { color: "white", flat: "" } },
        [
          _c(
            "fieldset",
            { staticClass: "inline-form input-38" },
            [
              _c("v-text-field", {
                attrs: { "append-icon": "mdi-filter", label: "Type to filter" },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              }),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  items: _vm.rigsDropBox,
                  "menu-props": { maxHeight: "400" },
                  label: "Select Rig",
                  "item-text": "rig",
                  "item-value": "id"
                },
                model: {
                  value: _vm.selectedRig,
                  callback: function($$v) {
                    _vm.selectedRig = $$v
                  },
                  expression: "selectedRig"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", dark: "" },
                  on: {
                    click: function($event) {
                      _vm.dialog = true
                    }
                  }
                },
                [_vm._v("Add Component")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.dialog = false
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "lighten-1" } },
            [
              _c(
                "v-toolbar",
                [
                  _c("v-toolbar-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(_vm._s(_vm.formTitle))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              staticClass: "row",
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "12" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.componentTypes,
                                      "item-text": "name",
                                      "item-value": "id",
                                      label: "Type"
                                    },
                                    model: {
                                      value: _vm.editedItem.component_type_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "component_type_id",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.component_type_id"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "fieldset",
                                    { staticClass: "inline-form" },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Number" },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: { label: "SN" },
                                        model: {
                                          value: _vm.editedItem.SN,
                                          callback: function($$v) {
                                            _vm.$set(_vm.editedItem, "SN", $$v)
                                          },
                                          expression: "editedItem.SN"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "fieldset",
                                    { staticClass: "inline-form input-3" },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "date-time-field",
                                        attrs: {
                                          type: "date",
                                          rules: _vm.req,
                                          label: "Date of Manufacture"
                                        },
                                        model: {
                                          value: _vm.editedItem.madeDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "madeDate",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.madeDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "jumps Number Check",
                                          required: "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.editedItem.jumpNumCheck,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "jumpNumCheck",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.jumpNumCheck"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.editedIndex == -1
                                    ? _c(
                                        "fieldset",
                                        { staticClass: "inline-form" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Qty",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.editedItem.qty,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "qty",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "editedItem.qty"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "date-time-field",
                                            attrs: {
                                              type: "date",
                                              label: "Last Check"
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .lastInspectionDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "lastInspectionDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.lastInspectionDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "fieldset",
                                    { staticClass: "inline-form" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Number of",
                                          required: "",
                                          type: "number",
                                          rules: _vm.req
                                        },
                                        model: {
                                          value: _vm.editedItem.interval,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "interval",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.interval"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          rules: _vm.req,
                                          items: ["days", "months", "years"],
                                          "item-text": "Interval",
                                          "item-value": "intervalType",
                                          value: _vm.editedItem.intervalType,
                                          label: "Interval"
                                        },
                                        model: {
                                          value: _vm.editedItem.intervalType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "intervalType",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.intervalType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Description" },
                                    model: {
                                      value: _vm.editedItem.description,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.description"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        type: "submit",
                        disabled: !_vm.valid
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          search: _vm.filter,
          headers: _vm.headers,
          items: _vm.componentsByRig,
          "items-per-page": 25,
          expanded: _vm.allExpandedComps,
          "item-class": _vm.row_classes,
          "show-expand": ""
        },
        on: {
          "update:expanded": function($event) {
            _vm.allExpandedComps = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item.lastInspectionDate",
            fn: function(ref) {
              var item = ref.item
              return [
                item.lastInspectionDate
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          new Date(
                            item.lastInspectionDate
                          ).toLocaleString("en-AU", {
                            timeZone: "UTC",
                            year: "numeric",
                            month: "short",
                            day: "numeric"
                          })
                        )
                      )
                    ])
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.nextInspectionDate",
            fn: function(ref) {
              var item = ref.item
              return [
                item.nextInspectionDate
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          new Date(
                            item.nextInspectionDate
                          ).toLocaleString("en-AU", {
                            timeZone: "UTC",
                            year: "numeric",
                            month: "short",
                            day: "numeric"
                          })
                        )
                      )
                    ])
                  : _vm._e()
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers
              var item = ref.item
              return [
                _c(
                  "td",
                  {
                    staticClass: "expanded-actions",
                    attrs: { colspan: headers.length }
                  },
                  [
                    _c("v-switch", {
                      attrs: {
                        success: item.status == 1 ? true : false,
                        inset: "",
                        label: _vm.getSwitchLabel(item.status)
                      },
                      on: {
                        change: function($event) {
                          return _vm.updateStatus(item)
                        }
                      },
                      model: {
                        value: item.status,
                        callback: function($$v) {
                          _vm.$set(item, "status", $$v)
                        },
                        expression: "item.status"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "blue--text",
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.reset(item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-update")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit(item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-pencil")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          disabled: item.status == 1,
                          icon: "",
                          small: "",
                          color: "red"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteComponent(item.id)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-delete-forever")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.jumpNumCheck",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", { staticClass: "jumpsCount" }, [
                  _c("b", [_vm._v(_vm._s(item.jumps || 0))]),
                  _vm._v("/"),
                  _c("small", [_vm._v(_vm._s(item.jumpNumCheck))])
                ]),
                _vm._v(" "),
                item.jumpsLeft
                  ? _c("span", { staticClass: "jumpsCount" }, [
                      _vm._v(_vm._s(item.jumpsLeft) + " left")
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }